export default __webpack_public_path__ + "static/media/world-map.3a67d2f8.png";